import { DWSMConfig } from '../models/DWSMConfig';
import { Plant } from '../models/Plant';
import { PlantCCDC } from '../models/PlantCCDC';
import { PsaAdmin } from '../models/PsaAdmin';
import { Technology } from '../models/Technology';
import { DefConfigVersion } from '../models/config-version/DefConfigVersion';
import { Building } from '../models/Building';
import { ProductLine } from '../models/ProductLine';
import { Derivative } from '../models/Derivative';

export interface MasterDataState {
    plants: Plant[];
    loadingPlants: boolean;
    technologies: Technology[];
    loadingTechnologies: boolean;
    psaAdmin: PsaAdmin[];
    loadingPsaAdmin: boolean;
    plantsCCDC: PlantCCDC[];
    globalDwsmConfig: DWSMConfig | null;
    activeConfigVersion: DefConfigVersion | null;
    loadingActiveConfigVersion: boolean;
    loadingPlantCCDC: boolean;
    buildings: Building[];
    productLines: ProductLine[];
    derivatives: Derivative[];
}

export const initialStateMasterData: MasterDataState = {
    plants: [],
    loadingPlants: false,
    technologies: [],
    loadingTechnologies: false,
    psaAdmin: [],
    loadingPsaAdmin: false,
    plantsCCDC: [],
    globalDwsmConfig: null,
    activeConfigVersion: null,
    loadingActiveConfigVersion: false,
    loadingPlantCCDC: false,
    buildings: [],
    productLines: [],
    derivatives: []
};

export const featureMasterDataKey = 'masterData';
